import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'usucampeao-registration-help',
  templateUrl: 'registration-help.modal.html',
  styleUrls: ['registration-help.modal.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class RegistrationHelpModal {

  constructor(
    public modalController: ModalController,
    public router: Router,
  ) {}

  dismiss() {
    this.modalController.dismiss();
  }

  navigateTo(rota: string): void {
    this.dismiss();
    if (rota !== 'dismiss') {
      this.router.navigate([rota]);
    }
  }
}
